import gql from 'graphql-tag';

export default gql(`
	query booking_capacity( $dates: [ String ], $kinds: [String], $subKinds: [String], $employeeGuid: String ) {
		booking_capacity( dates: $dates, kinds: $kinds, subKinds: $subKinds, employee_guid: $employeeGuid) {
			date
			item_kind
			item_guid
			timeslot_kind
			timeslot_sub_kind
			
			building_guid
			floor_guid
			room_guid
			
			capacity
			remaining
			
			favourites
			block_comment
			exception_kind
		}
	}
`);

